import { Component, EventEmitter, Output } from "@angular/core";
import { BookmarkUrl } from "src/app/constants/url/bookmark.url";
import { ResponseDto } from "src/app/dto/common/response.dto";
import { PointDto } from "src/app/dto/location/point.dto";
import { AccountService } from "src/app/service/account/account.service";
import { HttpService } from "src/app/service/http/http.service";

@Component({
    selector: 'bookmarkList',
    templateUrl: '../../view/bookmark/list.html'
})
export class BookmarkListComponent {
    public pointDtoList: PointDto[] = [];

    @Output() public editBookmarkEvent: EventEmitter<PointDto> = new EventEmitter<PointDto>();
    @Output() public bookmarkClickEvent: EventEmitter<PointDto> = new EventEmitter<PointDto>();
    @Output() public closeEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private httpService: HttpService, private accountService: AccountService) {}

    public edit(pointDto: PointDto): void {
        this.editBookmarkEvent.emit(pointDto);
    }

    public getList(): void {
        this.httpService.get<ResponseDto<PointDto[]>>(BookmarkUrl.get(this.accountService.getAccountSeq()))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.pointDtoList = [];
                    response.data.forEach(bookmark => {
                        this.pointDtoList.push(Object.assign(new PointDto(), bookmark));
                    });
                }
            });
    }

    public delete(bookmarkSeq: number): void {
        this.httpService.delete<ResponseDto<void>>(BookmarkUrl.delete(bookmarkSeq))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.getList();
                }
            });
    }

    public deleteAll(): void {
        this.httpService.delete<ResponseDto<void>>(BookmarkUrl.deleteAll(this.accountService.getAccountSeq()))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.pointDtoList = [];
                }
            });
    }

    public search(pointDto: PointDto): void {
        this.updateRegTime(pointDto);

        this.bookmarkClickEvent.emit(pointDto);
        this.close();
    }

    private updateRegTime(pointDto: PointDto): void {
        this.httpService.post<ResponseDto<void>>(BookmarkUrl.add, pointDto.toBookmarkDto());
    }

    public close(): void {
        this.closeEvent.emit();
    }
}